import { type FC, useState, useCallback } from 'react';
import { graphql, useFragment } from 'react-relay';
import classnames from 'classnames';

import dibsCss from 'dibs-css';
import { trackEvent, eventNameConstants, interactionTypeConstants } from 'dibs-tracking';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { BuyerIncentivesBannerCompactLazy } from 'dibs-buyer-incentives/exports/BuyerIncentivesBannerCompactLazy.ts';

import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext.tsx';
import { PdpSharedDibsPromiseModalLazy } from '../../PdpSharedModals/PdpSharedDibsPromiseModal/PdpSharedDibsPromiseModalLazy.tsx';

import { type PdpSharedBuyerIncentivesCompact_user$key } from './__generated__/PdpSharedBuyerIncentivesCompact_user.graphql.ts';

const userFragment = graphql`
    fragment PdpSharedBuyerIncentivesCompact_user on User {
        ...PdpSharedDibsPromiseModalLazy_user
    }
`;

export const PdpSharedBuyerIncentivesCompact: FC<{
    user: PdpSharedBuyerIncentivesCompact_user$key | null | undefined;
}> = ({ user: userRef }) => {
    const user = useFragment(userFragment, userRef);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const { isMobile } = useServerVarsContext();

    const handleOpenModal = useCallback(() => {
        setIsModalOpen(true);
        trackEvent({
            eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
            interaction_type: interactionTypeConstants.INTERACTION_TYPE_EBI_DETAILS,
            step_interaction_name: 'EBI seller info details click',
        });
    }, []);

    const handleCloseModal = useCallback(() => {
        setIsModalOpen(false);
    }, []);

    return (
        <>
            <BuyerIncentivesBannerCompactLazy
                isSingleItem
                getLink={chunk => <Link onClick={handleOpenModal}>{chunk}</Link>}
                contentClassName={classnames({
                    [dibsCss.itemsCenter]: !isMobile,
                })}
            />
            <PdpSharedDibsPromiseModalLazy
                user={user}
                isOpen={isModalOpen}
                onClose={handleCloseModal}
            />
        </>
    );
};
